document.addEventListener('DOMContentLoaded', () => {
    initBalance();
});

function initBalance() {
    const isBalance = document.querySelector('#updateBalanceData');
    if (!isBalance) {
        return;
    }

    const userDevice = new Balance();
    userDevice.init();
}

class Balance {

    constructor() {
        this.isProcessing = false;
    }

    init() {
        setInterval(() => {
            this.updateBalanceData();
        }, 1000);
    }

    updateBalanceData() {
        if (this.isProcessing) {
            return;
        }

        this.isProcessing = true;

        // Použití Naja.js pro AJAX požadavek
        naja.makeRequest('GET', document.querySelector('#updateBalanceData').value, null, {
            history: false
        }).then((data) => {
            this.isProcessing = false;
        }).catch(error => {
                console.error('Chyba při aktualizaci balančních dat:', error);
            });
    }
}
